module.exports = __webpack_public_path__ + "static/media/signup-photo.5f9e805c.png";